import { utils, write as writeFile } from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";
const convertToExcel = (tableData, fields, filename, customHeaders) => {
  // console.log('Fields:', fields);
  // console.log('Custom Headers:', customHeaders);
  // Filter out only the required fields from the table data
  var iCounter=0;
  const dataWithCustomHeaders = tableData.map((item) => {
    const dataItem = {};
    iCounter++;
    fields.forEach((field, index) => {
      
      if (field === "plotCoordinates" && item[field]) {
        // Format the plotCoordinates data
        const coordinates = JSON.parse(item[field])
          .map((coord) => `Lat: ${coord.latitude}, Long: ${coord.longitude}`)
          .join("; "); 
        dataItem[customHeaders[index]] = coordinates;
      }
      else  if (field === "srNo")
        {
          dataItem[customHeaders[index]] =  iCounter
        }
      else  if (field === "createdDate")
      {
        var created_Date =item[field]
        console.log("created_Date",created_Date)
        // created_Date= moment(created_Date.slice(0, 10)).format("DD/MM/YYYY")
        console.log("created_Date1",created_Date)
        dataItem[customHeaders[index]] = created_Date;
         
      }
       else {
        dataItem[customHeaders[index]] =
          item[field] === 0 ? 0 : item[field] || "";
      }
    });
    return dataItem;
  });

  // Create a new workbook
  const wb = utils.book_new();
  console.log("dataWithCustomHeaders",dataWithCustomHeaders);
  // Convert the filtered data to worksheet
  const ws = utils.json_to_sheet(dataWithCustomHeaders, {
    header: customHeaders,
  });
  

  // Add the worksheet to the workbook
  utils.book_append_sheet(wb, ws, "Sheet1");

  // const columnWidths = customHeaders&& customHeaders.map((header) => {
  //   const cellContent = utils.encode_col(utils.decode_col(header));
  //   return { wch: cellContent.length + 2 };
  // });
  const columnWidths = customHeaders.map((header) => ({
    wch: header.length + 10, // Add padding for better readability
  }));

  ws["!cols"] = columnWidths;

  const wbout = writeFile(wb, { bookType: "xlsx", type: "binary" });

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  saveAs(
    new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
    filename
  );
};
export default convertToExcel;
